module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[38]281.b4e350f.woff2";